export default {
    filterLabel: '滤镜',
    filterIcon:
        '<g stroke-width=".125em" stroke="currentColor" fill="none"><path d="M18.347 9.907a6.5 6.5 0 1 0-1.872 3.306M3.26 11.574a6.5 6.5 0 1 0 2.815-1.417 M10.15 17.897A6.503 6.503 0 0 0 16.5 23a6.5 6.5 0 1 0-6.183-8.51"/></g>',
    filterLabelChrome: '镶边',
    filterLabelFade: '淡化',
    filterLabelCold: '冷',
    filterLabelWarm: '暖',
    filterLabelPastel: '彩笔',
    filterLabelMonoDefault: '单色',
    filterLabelMonoNoir: '黑色',
    filterLabelMonoWash: '渍洗',
    filterLabelMonoStark: '黑白紫',
    filterLabelSepiaDefault: '棕褐',
    filterLabelSepiaBlues: '蓝调',
    filterLabelSepiaRust: '铁锈色',
    filterLabelSepiaColor: '颜色',
};
